import { DEFAULT_LANGUAGE, type Language } from '@faceup/utils'
import { createContext, type ReactNode, useContext, useMemo } from 'react'

type LocalizationContextType = {
  language: Language
}

const LocalizationContext = createContext<LocalizationContextType>({
  language: DEFAULT_LANGUAGE,
})

type LocalizationProviderProps = {
  children: ReactNode
} & LocalizationContextType

export const LocalizationProvider = ({ children, language }: LocalizationProviderProps) => {
  const value = useMemo(() => ({ language }), [language])
  return <LocalizationContext.Provider value={value}>{children}</LocalizationContext.Provider>
}

export const useLocalization = () => useContext(LocalizationContext)
